import { IframeAction, StorageType } from "../types";
import { getIframeData, updateStorageData } from "./iframe";
import { safeLocalStorage } from "./storage";

const ATTRIBUTION_EXPIRY_KEY = "BT_AM_ATTRIBUTION_EXPIRY";

export async function getAttributionExpiry(): Promise<number | undefined> {
  // if window.__bt_intrnl.recoveryUserAttr defined it means that
  // bt_tag or bt_am already tried to restore server side user attribution in current page view,
  // so the attribution expiry value could be getting from the window object;
  if (window.__bt_intrnl.recoveryUserAttr) {
    return window.__bt_intrnl.recoveryUserAttr.attributionExpiry;
  }

  const attributionExpiryStr = safeLocalStorage.get(ATTRIBUTION_EXPIRY_KEY);
  if (attributionExpiryStr) {
    return Number(attributionExpiryStr);
  }

  return getIframeData(StorageType.Local, ATTRIBUTION_EXPIRY_KEY)
    .then((iframeData) => {
      if (iframeData) {
        // set data to local storage so on next page load
        // it will be available without need to post message to iframe
        safeLocalStorage.set(ATTRIBUTION_EXPIRY_KEY, iframeData);
        return Number(iframeData);
      }
      return undefined;
    })
    .catch(() => undefined);
}

export const setAttributionExpiry = async (expiry: number) =>
  updateStorageData(
    IframeAction.Set,
    StorageType.Local,
    ATTRIBUTION_EXPIRY_KEY,
    expiry.toString(),
  );

export const deleteAttributionExpiry = async () =>
  updateStorageData(
    IframeAction.Delete,
    StorageType.Local,
    ATTRIBUTION_EXPIRY_KEY,
  );
